import React from 'react'
import TwitterIcon from '@mui/icons-material/Twitter';

const Twitter = () => {
    return (
        <div>
        <TwitterIcon color="info" />
            Twitter
        </div>
    )
}

export default Twitter
